import { isThaiTitle, dayjs } from '@shared/utils';

import { IdentifyProgressBar } from '../../../../components';
import { useEkyc } from '../../../../providers';

import { IdCardConfirmationFormLogic, type IdCardConfirmationFormType } from './_containers';
import { idCardNumberFormatter, laserNumberFormatter } from './utils';

export default function IDDetailsConfirmation() {
  const { citizenCardData } = useEkyc();

  const dateOfBirth = dayjs(citizenCardData?.dateOfBirth);

  const rawCardExpirationDate = citizenCardData?.expiryDate
    ? dayjs(citizenCardData.expiryDate)
    : null;
  const now = dayjs();
  const upperBound = now.add(20, 'year');
  const validatedCardExpirationDate =
    rawCardExpirationDate &&
    rawCardExpirationDate.isAfter(now, 'day') &&
    rawCardExpirationDate.isBefore(upperBound, 'day')
      ? rawCardExpirationDate
      : null;

  const formattedCitizenCardFrontData: IdCardConfirmationFormType = {
    idCardNumber: idCardNumberFormatter(citizenCardData?.idNumber ?? ''),
    ...(citizenCardData?.title && isThaiTitle(citizenCardData.title)
      ? {
          title: citizenCardData.title,
        }
      : {}),
    firstName: citizenCardData?.firstname ?? '',
    middleName: citizenCardData?.middleName ?? '',
    lastName: citizenCardData?.lastname ?? '',
    dateOfBirth: {
      date: dateOfBirth.date().toString(),
      month: dateOfBirth.month().toString(),
      year: dateOfBirth.year().toString(),
    },
    cardExpirationDate: {
      date: validatedCardExpirationDate?.date().toString() ?? '-',
      month: validatedCardExpirationDate?.month().toString() ?? '-',
      year: validatedCardExpirationDate?.year().toString() ?? '-',
    },
    laserNumber: laserNumberFormatter(citizenCardData?.idCode ?? ''),
  } satisfies Partial<IdCardConfirmationFormType> as IdCardConfirmationFormType;

  return (
    <div className='flex h-dvh w-full flex-col items-center'>
      <IdentifyProgressBar currentStep={2} />
      <IdCardConfirmationFormLogic defaultValues={formattedCitizenCardFrontData} />
    </div>
  );
}
